class RatingDetailController {
    constructor($stateParams, $window, $timeout, shopPageStateService) {
        this.$stateParams = $stateParams;
        this.$window = $window;
        this.$timeout = $timeout;
        this.shopPageStateService = shopPageStateService;
    }

    $onInit() {
        this.starData = [
            { star: 5, count: this.rating.FiveStarCount, percentage: this.rating.FiveStarPercentage },
            { star: 4, count: this.rating.FourStarCount, percentage: this.rating.FourStarPercentage },
            { star: 3, count: this.rating.ThreeStarCount, percentage: this.rating.ThreeStarPercentage },
            { star: 2, count: this.rating.TwoStarCount, percentage: this.rating.TwoStarPercentage },
            { star: 1, count: this.rating.OneStarCount, percentage: this.rating.OneStarPercentage },
        ];
    }
}

RatingDetailController.$inject = ['$stateParams', '$window', '$timeout', 'ShopPageStateService'];

const ratingDetailComponentDefinition = {
    controller: RatingDetailController,
    template: require('./rating-detail.component.html').trim(),
    bindings: {
        rating: '<',
    },
};

module.exports = {
    RatingDetailController,
    ratingDetailComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/rating/rating-detail.component.js